<template>
	<b-tab :title="item.code" active-tab-class="text-secondary" lazy>
	    <b-form-group>
	         <b-form-input id="query" :placeholder="`Filter in ${item.name}...`" v-model="filters.search" />
	    	<!-- <b-badge href="#" @click="byTag(tag)" variant="light" v-for="tag in tags">{{ tag }}</b-badge> -->
	    </b-form-group>
	    <b-form-group class="text-center d-none d-md-block" v-slot="{ ariaDescribedby }">
	      	<b-form-radio-group
	      		size="sm"
		        v-model="filters.tag"
		        :aria-describedby="ariaDescribedby"
		        name="tags"
		        button-variant="light"
		        buttons>
				<b-form-radio value="">ALL</b-form-radio>
				<b-form-radio v-for="tag in tags" :value="tag" :key="`tag-${tag}`">
					{{ tag }}
				</b-form-radio>
	        </b-form-radio-group>
	    </b-form-group>
	    <b-list-group flush>
	        <b-list-group-item button v-for="icd10 in codes" :key="`icd10-${icd10.id}`" class="d-flex justify-content-between align-items-center" @click="$emit('selected', icd10)">
	            <span><strong>{{icd10.code}}</strong> - {{icd10.name}}</span>
	            <b-badge :variant="`${icd10.color}-icd10`" pill>{{ icd10.tag }}</b-badge>
	        </b-list-group-item>

			<b-list-group-item v-show="!hasCodes" class="text-center">No ICD-10 Codes found.</b-list-group-item>
	    </b-list-group>

	</b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
	props: ['item'],
    data() {
        return {
        	tags: [],
        	filters: {
        		search: "",
        		tag: ""
        	},
        	codes: []
        }
	},
	watch: {
		filters: {
			immediate: true,
			deep: true,
			handler(val) {
				this.filterItems()
			}
		}
	},
    computed: {
    	...mapState('catalogue', {
    		icd10: state => state.icd10_codes,
    	}),
        hasCodes() {
        	return this.codes.length > 0
        }
    },
	methods: {
        ...mapActions('catalogue', ['getCatalogueItem']),

		searchFilter(data, searchString, tag) {
		    return data.filter(item => {
		        // Search string filter
		        const searchStringMatch = searchString === "" || 
		            Object.values(item).some(value =>
		                typeof value === 'string' &&
		                value.toLowerCase().includes(searchString.toLowerCase())
		            )

		        // Tag filter
		        const tagMatch = tag === "" || item.tag === tag

		        return searchStringMatch && tagMatch
		    })
		},

        filterItems() {
        	// Level 1: Direct children (groups under chapter)
        	const directChildren = this.icd10.filter(child => child.parent === this.item.code)
        	
        	// Level 2: Descendants (codes under groups)
        	const groupCodes = directChildren.map(group => group.code)
        	const level2 = this.icd10.filter(child => groupCodes.includes(child.parent))
        	
        	// Level 3: Sub-descendants (subcodes under codes)
        	const codeCodes = level2.map(code => code.code)
        	const level3 = this.icd10.filter(child => codeCodes.includes(child.parent))
        	
        	// Combine all three levels
        	const allItems = [...directChildren, ...level2, ...level3]
        	
        	this.codes = this.searchFilter(allItems, this.filters.search, this.filters.tag)
        },
        async filterTags() {
        	// Level 1: Direct children
        	const directChildren = this.icd10.filter(child => child.parent === this.item.code)
        	
        	// Level 2: Descendants
        	const groupCodes = directChildren.map(group => group.code)
        	const level2 = this.icd10.filter(child => groupCodes.includes(child.parent))
        	
        	// Level 3: Sub-descendants
        	const codeCodes = level2.map(code => code.code)
        	const level3 = this.icd10.filter(child => codeCodes.includes(child.parent))
        	
        	// Get all unique tags from all three levels
        	const allItems = [...directChildren, ...level2, ...level3]
        	this.tags = await [...new Set(allItems.map((item) => item.tag).filter(tag => tag))] 
        }
	},

	async mounted() {
		await this.getCatalogueItem('icd10_codes')
		await this.filterItems()
		await this.filterTags()
	}
}
</script>
